module.exports = __webpack_public_path__ + "img/14.735fc11a.png";